import { defineStore } from 'pinia';
import { useHttp } from '@/http/http';
import { statusCheck } from '../public';

// 日期格式化函數
const formatDate = (date) => {
  if (!date) return '';
  const d = new Date(date);
  const month = `${d.getMonth() + 1}`.padStart(2, '0');
  const day = `${d.getDate()}`.padStart(2, '0');
  const year = d.getFullYear();
  return `${year}-${month}-${day}`;
};

export const useSettlementStore = defineStore('settlement', {
  state: () => ({
    settlements: [], 
    totalEntries: 0,
    currentPage: 1,
    itemsPerPage: 10,
    filters: {
      fromDate: '',
      toDate: '',
      reference: ''
    }
  }),
  actions: {
    async fetchSettlements(page = 1, perPage = this.itemsPerPage) {
      const url = `/api/driver/settlement/list`;
      let params = new URLSearchParams();

      params.append('per_page', perPage);
      params.append('page', page);

      // 格式化日期
      if (this.filters.fromDate) params.append('from', formatDate(this.filters.fromDate));
      if (this.filters.toDate) params.append('to', formatDate(this.filters.toDate));
      if (this.filters.reference) params.append('settlement_ref', this.filters.reference);

      try {
        const response = await useHttp().get(`${url}?${params.toString()}`);
        if (statusCheck(response.data)) {
          // 假設API返回的結構為{ payments: [], total: 10, current_page: 1, last_page: 1 }
          this.settlements = Object.values(response.data.payments).flat(); // 將日期分組的交易合併為單一陣列
          this.totalEntries = response.data.total;
          this.currentPage = response.data.current_page;
        } else {
          console.error('Failed to fetch settlements:', response.data.message);
        }
      } catch (error) {
        console.error('Error fetching settlements:', error);
        throw error;
      }
    },
  },
  getters: {
    totalPages(state) {
      return Math.ceil(state.totalEntries / state.itemsPerPage);
    },
  }
});
